import ikuReducer from "./reducers";

export default ikuReducer